export const modalTheme = {
  modalWidthAccess: 520,
  modalWidthPayment: 430,
  radiusLg: 12,
  radiusMd: 10,
  radiusSm: 8,
  shadowQr: '0 8px 20px rgba(15, 23, 42, 0.08)',
  spacingXs: 6,
  spacingSm: 8,
  spacingMd: 10,
  spacingLg: 12,
  spacingXl: 14,
  spacing2xl: 16,
  spacing3xl: 40,
  fontXs: 12,
  fontSm: 13,
  fontMd: 14,
  fontPrice: 30,
  lineHeightRelaxed: 1.7,
  primaryGradient: 'linear-gradient(90deg, #0ea5e9 0%, #06b6d4 100%)',
  paymentBgGradient: 'linear-gradient(180deg, #f0f9ff 0%, #ffffff 75%)',
  paymentBorder: '#dbeafe',
  paymentBadgeBg: '#e0f2fe',
  paymentBadgeText: '#0369a1',
  amountText: '#dc2626',
  secondaryText: '#475569',
  cardText: '#0f172a',
  accessWarnBg: 'linear-gradient(90deg, #fff7ed 0%, #fffbeb 100%)',
  accessWarnBorder: '#fed7aa',
  accessWarnText: '#9a3412',
  accessExpireText: '#b45309',
  contactCardBg: '#f8fafc',
  contactCardText: '#334155',
  contactPhoneText: '#0f766e',
  secondaryButtonBorder: '#cbd5e1',
}
